(function () {
  'use strict';

  document.addEventListener('click', function (ereignis) {
    var ausloeser = ereignis.target.closest('[data-video-laden]');
    if (!ausloeser) return;

    var kasten = ausloeser.closest('.video-zustimmung');
    if (!kasten) return;

    var kennung = kasten.getAttribute('data-video');
    if (!kennung || !/^[A-Za-z0-9_-]{6,}$/.test(kennung)) return;

    ereignis.preventDefault();

    var rahmen = document.createElement('div');
    rahmen.className = 'video-zustimmung__rahmen';

    var fenster = document.createElement('iframe');
    fenster.src = 'https://www.youtube-nocookie.com/embed/' + kennung + '?rel=0&autoplay=1';
    fenster.title = kasten.getAttribute('data-titel') || 'Video';
    fenster.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    fenster.setAttribute('allowfullscreen', '');
    rahmen.appendChild(fenster);

    kasten.innerHTML = '';
    kasten.appendChild(rahmen);
    fenster.focus();
  });

  var schacht = null;
  var vorherFokus = null;

  function bauen() {
    if (schacht) return schacht;
    schacht = document.createElement('div');
    schacht.className = 'vzds';
    schacht.hidden = true;
    schacht.innerHTML =
      '<div class="vzds__hinter" data-vzds-zu></div>' +
      '<div class="vzds__dialog" role="dialog" aria-modal="true" aria-labelledby="vzds-titel" tabindex="-1">' +
        '<div class="vzds__kopf">' +
          '<h2 id="vzds-titel">Datenschutzerklärung</h2>' +
          '<button type="button" class="vzds__schliessen" aria-label="Fenster schließen" data-vzds-zu>&times;</button>' +
        '</div>' +
        '<div class="vzds__inhalt"><p>Wird geladen …</p></div>' +
        '<div class="vzds__fuss">' +
          '<a class="vzds__mehr" href="/pages/datenschutz" target="_blank" rel="noopener">Auf eigener Seite öffnen ↗</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(schacht);
    schacht.addEventListener('click', function (e) {
      if (e.target.closest('[data-vzds-zu]')) { schliessen(); return; }
      var sprung = e.target.closest('.vzds__inhalt a[href^="#"]');
      if (!sprung) return;
      e.preventDefault();
      var ziel = schacht.querySelector(
        '.vzds__inhalt [id="' + sprung.getAttribute('href').slice(1) + '"]');
      if (ziel) ziel.scrollIntoView({ block: 'start' });
    });
    return schacht;
  }

  function saeubern(knoten) {
    var weg = knoten.querySelectorAll('script, style, iframe, object, embed, form');
    Array.prototype.forEach.call(weg, function (x) { x.parentNode.removeChild(x); });
    var links = knoten.querySelectorAll('a[href^="http"]');
    Array.prototype.forEach.call(links, function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
    return knoten;
  }

  function inhaltHolen() {
    var ziel = schacht.querySelector('.vzds__inhalt');
    if (ziel.getAttribute('data-geladen') === 'ja') return;
    fetch('/pages/datenschutz', { credentials: 'same-origin' })
      .then(function (a) { return a.text(); })
      .then(function (text) {
        var seite = new DOMParser().parseFromString(text, 'text/html');
        var quelle = seite.querySelector('.page-rte') || seite.getElementById('MainContent');
        if (!quelle) throw new Error('Inhalt nicht gefunden');
        var huelle = document.createElement('div');
        huelle.appendChild(document.importNode(quelle, true));
        ziel.innerHTML = '';
        ziel.appendChild(saeubern(huelle));
        ziel.scrollTop = 0;
        ziel.setAttribute('data-geladen', 'ja');
      })
      .catch(function () {
        ziel.innerHTML = '<p>Die Datenschutzerklärung lässt sich gerade nicht laden. '
          + 'Bitte öffnen Sie sie über den Link unten.</p>';
      });
  }

  function greifbar() {
    return Array.prototype.slice.call(schacht.querySelectorAll(
      '.vzds__dialog a[href], .vzds__dialog button:not([disabled])'));
  }

  function beiTaste(e) {
    if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
    if (e.key !== 'Tab') return;
    var teile = greifbar();
    if (!teile.length) return;
    var erst = teile[0], letzt = teile[teile.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  }

  function schliessen() {
    if (!schacht) return;
    schacht.hidden = true;
    document.body.classList.remove('vzds-offen');
    document.removeEventListener('keydown', beiTaste);
    if (vorherFokus && typeof vorherFokus.focus === 'function') vorherFokus.focus();
  }

  document.addEventListener('click', function (ereignis) {
    var link = ereignis.target.closest('[data-vzds-open]');
    if (!link) return;
    if (!window.fetch || !window.DOMParser) return;
    ereignis.preventDefault();
    vorherFokus = link;
    bauen();
    schacht.hidden = false;
    document.body.classList.add('vzds-offen');
    schacht.querySelector('.vzds__schliessen').focus();
    document.addEventListener('keydown', beiTaste);
    inhaltHolen();
  });
})();
